import { memo } from 'react';
import { Box, DuoColorIcon, Icon, Text } from '@zillow/constellation-10';
import { IconDollarSignCircleFilled } from '@zillow/constellation-icons';

const TransactionsTableHeader = memo(
  ({ headerText, isDesktop = true }: { headerText: string; isDesktop?: boolean }) => {
    return (
      <Box
        css={{
          display: 'flex',
          alignItems: 'center',
          gap: 'tighter',
          ...(isDesktop && {
            paddingBottom: 'default',
            borderBottom: '{borderWidths.default} solid {colors.gray.300}',
          }),
          width: '100%',
        }}
      >
        <DuoColorIcon tone="info">
          <Icon>
            <IconDollarSignCircleFilled />
          </Icon>
        </DuoColorIcon>
        <Text textStyle="heading-xs" data-testid="RentReporting-TransactionHeader">
          {headerText}
        </Text>
      </Box>
    );
  },
);

TransactionsTableHeader.displayName = 'TransactionsTableHeader';

export default TransactionsTableHeader;
